import { Box, Stack, Typography,  } from '@mui/material'
import custom from '../../../styles/mui/szVariables.json'

export default function HourBar({ data }: any) {
    const colors: any = {
        'offPeak': 'sz.colors.orange200',
        'shoulder': 'sz.colors.orange300',
        'peak': 'sz.colors.orange400'
    }


    return (
        <Box width={`${((data.numberOfHours/24)*100).toFixed(0)}%`} 
            mr={custom.spacing.xxxxs}
            display="flex" 
            flexDirection={"column"}
            justifyContent={"center"}>  
            <Box height={custom.spacing.sm}
                sx={{ 
                    backgroundColor: colors[data.type],
                    borderRadius: custom.corners2,
                }} />
            <Stack alignItems="center" direction="row" 
                    justifyContent="center"
                    mt={custom.spacing.xxs}>
                <Typography variant='szBody.Regular.xxSmall'>   
                    {data?.from===0?
                        '12am':data?.from>12?
                        `${data?.from-12}pm`:`${data?.from}am`}
                </Typography>
                <Typography variant='szBody.Regular.xxSmall' 
                    ml="auto">   
                    {data?.to>22?`${data?.to-12}`:''}
                </Typography> 
            </Stack>   
        </Box>  
    )
}